import React, { useState } from "react";
import "../scss/Marketplace.scss";
import arrow_one from "../Images/arrow-one.png";
import arrow_two from "../Images/arrow-two.png";
import BidsCard from "../components/BidsCard";

const Marketplace = () => {
	const [value, setValue] = useState({
		price: "0.1",
	});

	const handleChange = (e) => {
		let newState = { ...value };
		newState[e.target.name] = e.target.value;
		setValue({
			...newState,
		});
	};
	return (
		<div className="marketplace">
			<div className="marketplace__container">
				<div className="marketplace__heroContainer">
					<div className="marketplace__hero">
						<p className="marketplace__hero__heading">
							Currency <span>Swapping</span> is easier than ever...
						</p>

						<div className="marketplace__conversion">
							<div className="marketplace__conversion__wrapper">
								<p>What commodity do you want</p>
								<div className="marketplace__conversion__bottom">
									<div>
										<input
											type="number"
											value={value.price}
											name="price"
											onChange={handleChange}
											placeholder="Please enter a value"
										/>
										<select name="" id="">
											<option value="USD">$USD</option>
										</select>
									</div>
									<div>
										<button className="marketplace__conversion__buy">
											BUY <img src={arrow_two} alt="" />
										</button>
										<button className="marketplace__conversion__sell">
											SELL <img src={arrow_one} alt="" />
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div className="marketplace__bid">
					<div className="marketplace__bidTop">
						<p>Available Bids from Organisation</p>
						<button>View More</button>
					</div>
					<div className="marketplace__bidBottom">
						<BidsCard/>
						<BidsCard/>
						<BidsCard/>
						<BidsCard/>
						<BidsCard/>
					</div>
				</div>

				<div className="marketplace__bid">
					<div className="marketplace__bidTop">
						<p>Available Bids from Organisation</p>
						<button>View More</button>
					</div>
					<div className="marketplace__bidBottom">
						<BidsCard/>
						<BidsCard/>
						<BidsCard/>
						<BidsCard/>
						<BidsCard/>
					</div>
				</div>

				<div className="marketplace__bid">
					<div className="marketplace__bidTop">
						<p>Available Bids from Organisation</p>
						<button>View More</button>
					</div>
					<div className="marketplace__bidBottom">
						<BidsCard/>
						<BidsCard/>
						<BidsCard/>
						<BidsCard/>
						<BidsCard/>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Marketplace;
